module.exports = __webpack_public_path__ + "media/fonts/CircularStd-Medium-6fb73f93b89db3da0c34ce5b6ca7b416.ttf";